/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site.fancybox', [
        'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css',
        'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js',
    ], function (e) {
        Fancybox.bind("[data-fancybox]", {
            groupAll: true,
            Thumbs: {
                autoStart: false,
            },
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
